// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Vendor
 */
export interface Vendor {
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    contact_email?: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    contact_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    created_by: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    vendor_id: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    vendor_name: string;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    vendor_type?: string;
}

/**
 * Check if a given object implements the Vendor interface.
 */
export function instanceOfVendor(value: object): value is Vendor {
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('vendor_id' in value) || value['vendor_id'] === undefined) return false;
    if (!('vendor_name' in value) || value['vendor_name'] === undefined) return false;
    return true;
}

export function VendorFromJSON(json: any): Vendor {
    return VendorFromJSONTyped(json, false);
}

export function VendorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Vendor {
    if (json == null) {
        return json;
    }
    return {
        
        'contact_email': json['contact_email'] == null ? undefined : json['contact_email'],
        'contact_name': json['contact_name'] == null ? undefined : json['contact_name'],
        'created_at': json['created_at'],
        'created_by': json['created_by'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'vendor_id': json['vendor_id'],
        'vendor_name': json['vendor_name'],
        'vendor_type': json['vendor_type'] == null ? undefined : json['vendor_type'],
    };
}

export function VendorToJSON(json: any): Vendor {
    return VendorToJSONTyped(json, false);
}

export function VendorToJSONTyped(value?: Vendor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact_email': value['contact_email'],
        'contact_name': value['contact_name'],
        'created_at': value['created_at'],
        'created_by': value['created_by'],
        'notes': value['notes'],
        'vendor_id': value['vendor_id'],
        'vendor_name': value['vendor_name'],
        'vendor_type': value['vendor_type'],
    };
}
